import { Component, Input } from '@angular/core';
import { TasksService } from '../tasks.service';
import { Observable } from 'rxjs';
import { Task } from '../task.type';
import { ActionButtonImages } from 'app/shared/components/action-button/action-button-images.enum';
import { map, tap } from 'rxjs/operators';

@Component({
  selector: 'ls-tasks-popover',
  templateUrl: './task-popover.component.html',
  styleUrls: ['./task-popover.component.scss']
})
export class TasksPopoverComponent {
  tasks$: Observable<Task[]>;
  numberOfActiveTasks$: Observable<number>;
  maximized = true;
  actionImages = ActionButtonImages;

  @Input()
  sidebarStatus: { [key: string]: boolean } = {};

  constructor(private tasksService: TasksService) {
    this.tasks$ = tasksService.activeTasks$;
    this.numberOfActiveTasks$ = this.tasks$.pipe(
      tap(() => (this.maximized = true)),
      map(tasks => tasks.filter(task => task.status === 'pending').length)
    );
  }

  getClass() {
    return {
      minimized: !this.maximized,
      ...this.sidebarStatus
    };
  }

  removeTask(task: Task) {
    this.tasksService.removeTask(task.id);
  }

  getResult(task: Task) {
    this.tasksService.getResult(task.id);
  }
}
